module.exports = __webpack_public_path__ + "media/images/cbjj/card-5530da7be82cf5f5b92fa094076f346b.jpg";